import { useSchoolYear } from '@pelckmans/business-components/context/SchoolYearContext';
import { useTranslation } from 'react-i18next';
import LoadingState from '../../../shared-components/LoadingState';
import useStudentGroups from '../hooks/useStudentGroups';
import { toId } from '../utils';
import TeacherSections from '../components/TeacherSections';

export default function CurrentYearTab() {
  const { currentSchoolYear } = useSchoolYear();
  const { t } = useTranslation();

  const { loading } = useStudentGroups(toId(currentSchoolYear));

  if (loading || !currentSchoolYear)
    return <LoadingState variant="list" aria-label={t('PAGES.MY_TEACHERS.CURRENT_YEAR_TAB.LOADING.A11Y_LABEL')} />;

  return <TeacherSections currentSchoolYear={currentSchoolYear} />;
}
